<div
  class="stc-container-fields"
  [formGroup]="form">
  <app-input-vocabulary-autocomplete
    formControlName="STCC"
    [vocabularyName]="'V_STCC'"
    [placeholder]="'Stato di conservazione (STCC)'">
  </app-input-vocabulary-autocomplete>
  <mat-form-field>
    <textarea
      matInput
      placeholder="Indicazioni specifiche (STCS)"
      formControlName="STCS"></textarea>

  </mat-form-field>
</div>
